import axios from "axios";
import InstanceApi from "@/services/apiClient.js";
import {
  formatSaveWizardRequest
} from "@/helpers/wizard";


const SAVE_WIZARD_URL = "mcp/checkout/saveWizardWidget";


const setWizardInfoDataRequired = (state, payload) => {
  state.commit("SET_WIZARD_INFO_DATA_REQUIRED", payload);
};

const setWizardInfoOptional = (state, payload) => {
  state.commit("SET_WIZARD_INFO_OPTIONAL", payload);
};

const setWizardFillPercent = (state, percent) => {
  state.commit("SET_WIZARD_FILL_PERCENT", percent);
};

const setWizardFillPercentLast = (state, percent) => {
  state.commit("SET_WIZARD_FILL_PERCENT_LAST", percent);
};

const addRequiredCompanyToStore = state => {
  state.rootState.Wizard.wizard.required.infos["company"] = "";
};

const toogleInfoDataRequired = (state, payload) => {
  let arrayToConvert = state.rootState.Wizard.wizard.billingInfo;
  let arrayWithData = state.rootState.Wizard.wizard.required.infos;
  if (payload) {
    Object.entries(arrayWithData).forEach(element => {
      if(arrayToConvert.hasOwnProperty(element[0])) {
      arrayToConvert[element[0]] = element[1];
      }
    });
    Object.entries(arrayToConvert).forEach(element => {
      delete arrayWithData[element[0]];
    });
  } else {
    Object.entries(arrayToConvert).forEach(element => {
      arrayWithData[element[0]] = element[1];
    });
  }
};

const removeRequiredCompanyToStore = state => {
  delete state.rootState.Wizard.wizard.required.infos.company;
};

const validateRecaptchaToken = () => {
  
  return new Promise((res, rej) => {

    window.grecaptcha.ready(function() {

      window.grecaptcha.execute(window.recaptchaSiteKey, {action: 'submit'}).then(function(token) {
        return res(token);
      });
    }); 
    
  });
};

const doSaveWizard = async ({ getters, rootGetters }) => {
  try {

    let recaptchaToken;
    if(window.recaptchaSiteKey !== undefined){
      recaptchaToken = await validateRecaptchaToken();
    }

    const requiredInfo = getters.getWizardInfoRequired;
    const additionalInfo = getters.getWizardInfoOptional;
    const currentUserShippingInfo = rootGetters.getCurrentUserShippingInfo;
    const formAnswers = getters.getWizardFormAnswers;

    const gclidInput = document.querySelector('#gclid_field');
    let gclidValue = gclidInput ? {
      'mcp_gclid': gclidInput.value
    } : {
      'mcp_gclid': ''
    };

    const fbclidInput = document.querySelector('#fbclid_field');
    let fbclidValue = fbclidInput ? {
      'mcp_fbclid': fbclidInput.value
    } : {
      'mcp_fbclid': ''
    };

    /* format saveWizard data */
    let bodyFormData = formatSaveWizardRequest(
      requiredInfo,
      additionalInfo,
      currentUserShippingInfo,
      gclidValue,
      fbclidValue,
      formAnswers,
      recaptchaToken
    );

    /* call save wizard data */
    const saveWizardResponse = await InstanceApi.post(SAVE_WIZARD_URL, bodyFormData);

    /* in case saveWizardResponse failed, we exit the checkout process */
    if (saveWizardResponse.data.success == false && saveWizardResponse.data.message)
      throw saveWizardResponse.data.message || "failure";
    
    if (saveWizardResponse.data.success == false || !saveWizardResponse.data.url) {
      throw "Une erreur est survenue, veuillez réessayer plus tard"
    } else {
      /* in case of success, we redirect the user to the confirmation page */
      window.location.href = saveWizardResponse.data.url;
    }
  } catch (err) {
    console.error("saveWizard failure", err);
    return { error: err };
  }
  return { success: "" };
};

const initStrapiForm = async (state) => {

  let strapiFormId = typeof window.landingQa !== 'undefined' ? landingQa : 0;
  let strapiFormCollection = "form-pacs";

  let productStrapiFormId = state.rootState.Product.mcp_form_strapi_id;

  if(productStrapiFormId){
    strapiFormId = productStrapiFormId;
    strapiFormCollection = "formulaires-page-produits";
  }

  state.commit("SET_STRAPI_FORM_ID", strapiFormId);

  const STRAPI_FORM_URL = `${process.env.VUE_APP_URL_STRAPI}/${strapiFormCollection}?id=${strapiFormId}`;

  /* get strapi form data */
  const getStrapiForm = await axios.get(STRAPI_FORM_URL).catch((error) => {
    if (error.response) {
      // Request made and server responded
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
    } else if (error.request) {
      // The request was made but no response was received
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error', error.message);
    }
  });

  const form = getStrapiForm.data;
  state.commit("SET_STRAPI_FORM", form);
};

const setWizardFormAnswers = (state, payload) => {
  state.commit("SET_FORM_ANSWERS", payload);
};

const setWizardOptinData = (state, payload) => {
  state.commit("SET_WIZARD_OPTIN_DATA", payload);
};

export default {
  setWizardInfoDataRequired,
  setWizardInfoOptional,
  setWizardFillPercent,
  setWizardFillPercentLast,
  addRequiredCompanyToStore,
  removeRequiredCompanyToStore,
  toogleInfoDataRequired,
  doSaveWizard,
  initStrapiForm,
  setWizardFormAnswers,
  setWizardOptinData
};
